define('lq/events/actions/update',[
    'lq/events/actions/eventAction',
    'jquery',
    'underscore',
    'lq/uploader',
    'lq/entityFiltersState',
    'lq',
    'lq/events/abortError',
    'when'
], function (EventAction, $, _, Uploader, entityFiltersState, lq, AbortError, when) {
    'use strict';

    function Update(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(Update, EventAction);

    Update.typeName = 'Update';

    Update.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    Update.prototype.createEventActionRequest = function () {
        return this.validateData.bind(this);
    };

    Update.prototype.validateData = function (requestContinuation, requestCancellation) {
        var self = this;

        this.isDataValid()
            .then(function(isValid) {
                if(isValid) {
                    if (self.eventIsEnabled('inputValidated')) {
                        self.triggerEvent('inputValidated');
                    }
                    self.buildRequest(requestContinuation, requestCancellation);
                }
                else {
                    if (self.eventIsEnabled('inputInvalidated')) {
                        self.triggerEvent('inputInvalidated');
                    }
                    requestCancellation();
                }
            });
    };

    Update.prototype.buildRequest = function (requestContinuation, requestCancellation) {
        var self = this;

        var commandViewModelKeysValues = {};

        _.each(self.eventData.commandViewModelKeys, function (key) {
            var drop = self.piping.dropFactory.findDropByViewModelKey(key);
            var value = drop.getValue();
            commandViewModelKeysValues[key] = value;
        });

        var extraProperties = {};

        if (self.eventData.isEntityFilterEntity)
            extraProperties['Filter'] = entityFiltersState.getStateOfEntityFilters(this.rootDrop);

        var request = {
            eventActionType: "Update",
            command: self.eventData.command,
            commandViewModelKeys: commandViewModelKeysValues,
            uploads: [],
            extraProperties: extraProperties,
            captcha: this.getCaptcha()
        };

        if (self.eventData.fileUploadType === null) {
            requestContinuation(request);
        } else if (self.eventData.fileUploadType === 'fromViewModel') {
            var drop = self.piping.dropFactory.findDropByViewModelKey(self.eventData.fileSourceMorph);
            
            if(self.requiredValueIsFilledIn(drop)) {
                when(drop.getFile())
                    .then(function (content) {
                        $.ajax({
                            type: 'POST',
                            url: lq.getTenantUrl('DynamicContent/AddPromptlessTempFile'),
                            contentType: "application/json; charset=utf-8",
                            data: content,
                            dataType: 'json'
                        }).done(function (response) {
                            if (response.success) {
                                request.uploads.push(
                                    {
                                        fileName: response.fileName,
                                        tempUrl: response.tempUrl
                                    });
                                requestContinuation(request);
                            };
                        });
                    });
            } else {
                requestCancellation();
            }
        } else if (self.eventData.fileUploadType === 'fromParameter') {
            var file = self.piping.parameters.getValue(self.eventData.fileSourceParameter);
            var xhr = new XMLHttpRequest();
            var fd = new FormData();
            var url = lq.getTenantUrl('DynamicContent/AddTempFile');
            xhr.open("POST", url, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState !== 4)
                    return;
                if (xhr.status === 200) {
                    var response = JSON.parse(xhr.responseText);
                    request.uploads.push(
                        {
                            fileName: response.fileName,
                            tempUrl: response.tempUrl
                        });
                    requestContinuation(request);
                }
            };
            fd.append("qqfile", file);
            xhr.send(fd);
        } else {
            var uploader = new Uploader(self.piping)
                .toTenantUrl("DynamicContent/AddTempFile")
                .withFileFilter(self.eventData.fileUploadAllowedFileTypes === 'custom' ?
                    self.eventData.fileUploadAllowedCustomFileTypes : self.eventData.fileUploadAllowedFileTypes)
                .withMaxFileSize(self.eventData.maxFileSize)
                .withSmartphoneMode(self.eventData.fileUploadModeSmartPhone)
                .withPhotoQuality(self.eventData.photoQuality)
                .withMaxImageDimensions(self.eventData.maxImageDimensions)
                .onFileUploaded(function (uploadResponse) {
                    if (!uploadResponse.success)
                        throw new Error('Upload failed.');

                    request.uploads.push(
                        {
                            fileName: uploadResponse.filename,
                            tempUrl: uploadResponse.tempUrl
                        });
                })
                .onUploadFinished(function () {
                    requestContinuation(request);
                });
            if (self.eventIsEnabled('maxFileSizeExceeded')) {
                uploader
                    .onMaxFileSizeExceeded(function () {
                        self.triggerEvent('maxFileSizeExceeded');
                    })
            }
            if (self.eventData.fileUploadType === "singleFile" || self.eventData.fileUploadType == "newFile") {
                uploader.uploadSingleFile();
            }
            else if (self.eventData.fileUploadType === "multipleFiles") {
                uploader.uploadMultipleFiles();
            }
        }
    };

    Update.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.isDirty){
            if (this.eventIsEnabled('onExecutionTrailDirty'))
                this.triggerEvent('onExecutionTrailDirty');
            else alert('Could not update the data, because the data is dirty.');
        }
        else continuation();
    };

    Update.prototype.requiredValueIsFilledIn = function (drop) {
        if (!this.eventData.skipRequiredFields && drop.isVisible() && !drop.isValid()) {
            if (this.eventIsEnabled('requiredFieldsMissing')) {
                this.triggerEvent('requiredFieldsMissing');
            } else {
                alert('* not all required fields are filled in.');
            }
            return false;
        }
        return true;
    };

    Update.prototype.getCaptcha = function () {
        if (!this.eventData.captchaField) return null;

        var captchaDrop = this.piping.dropFactory
            .findDropByName(this.eventData.captchaField);

        if (!captchaDrop.data.captchaInputField) return null;

        return this.piping.dropFactory
            .findDropByName(captchaDrop.data.captchaInputField)
            .getValue();
    };

    Update.prototype.isDataValid = function () {
        var self = this;
        return when.reduce(self.eventData.commandViewModelKeys, function(isDataValid, viewModelKey) {
            var drop = self.piping.dropFactory.findDropByViewModelKey(viewModelKey);

            if (!drop)
                throw 'Cannot find drop : "' + key + '" for create command.';

            if(!drop.isVisible())
                return isDataValid;

            if (!self.requiredValueIsFilledIn(drop))
                return false;

            return drop.performValidation(self.eventActionId)
                .then(function(isDropValid) {
                    return isDropValid ? isDataValid : false;
                });
        }, true);
    };

    return Update;
});
